<menu #prop class="no-margin">
  @for (prop of properties; track prop) {
    <div menu-item>
      <property-node [object]="prop" (selectedProperty)="selectedProperty.emit($event)" (onHover)="itemHoverChanged.emit($event)"></property-node>
    </div>
  }
</menu>

@if (properties) {
  <button title="Select Property" attr.aria-label="Select Property" class="minor-margin-left">
    <svg-icon icon="icon-report-selector" class="small input-height" aria-hidden="true" [menuFor]="prop" maxHeight="500px" [menuPosition]="position"></svg-icon>
  </button>
}

@if (properties) {
  <div class="checkbox cell small-8 display-inline-block">
    <label class="inline">
      Display Property Path Input:
      <input id="toggleManualView" type="checkbox" [(ngModel)]="displayManualPathEntry">
    </label>
  </div>
}

@if (displayManualPathEntry) {
  <div>
    <label class="no-margin">
      Property Path
      <input id="input" type="text"  [(ngModel)]="propertyPath" (ngModelChange)="generateProperty()" />
    </label>
  </div>
}